
export default function randomHash(size = 6) {
  const chars = '0123456789';
  let pass = '';
  for (let i = 0; i < size; i++) {
    pass += chars[Math.floor((Math.random() * chars.length))];
  }
  return pass;
}

export function randomHash15() {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let pass = '';
  for (let i = 0; i < 15; i++) {
    pass += chars[Math.floor((Math.random() * chars.length))];
  }
  return pass;
}